// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.75 3.5V12.5M8.5 3.5V12.5M2.75 8H8.5',
  'M10.75 7.75C10.75 6.15 14 6.15 14 7.85C14 9.05 12.95 9.6 12 10.4C11.3 11 10.75 11.5 10.75 12.5H14',
];
